<div class="container-wrapper d-flex pl-2">
  <div class="col-md-11 pr-0 pl-0">
    <div class="container-layout" [class.collapsed]="isCollapsed()">
      @if (!isCollapsed()) {
        <div class="remaining-space ">
          <div class="header">
            <div class="header-left">
              <img src="assets/icon/progress.png" alt="" />
              <h4>{{ "BLAST_HISTORY.PROGRESS" | translate }}</h4>
            </div>
          </div>
          <div class="overlay">
            @if (blastData() && blastData().Holes) {
              <div class="chart-section">
              </div>
            }
            <div class="content-section">
              @if (loading()) {
                <div class="loading-container">
                  <p>{{ "GLOBAL.CHARGEMENT" | translate }}</p>
                </div>
              }
              @if (!loading()) {
                <div class="history-title">
                  <h5>{{ "BLAST_HISTORY.HISTORY" | translate }}</h5>
                </div>
              }
              @if (!loading()) {
                <div class="table-wrapper">
                  <div class="table-container">
                    @if (blastJobs().length > 0) {
                      <table class="blast-history-table">
                        <thead>
                          <tr>
                            <th>{{ "BLAST_HISTORY.SOURCE" | translate }}</th>
                            <th>{{ "BLAST_HISTORY.USER" | translate }}</th>
                            <th>{{ "BLAST_HISTORY.DATE" | translate }}</th>
                            <th>{{ "BLAST_HISTORY.STATUS" | translate }}</th>
                          </tr>
                        </thead>
                        <tbody>
                          @for (job of blastJobs(); track job) {
                            <tr>
                              <td [title]="getFilePathTooltip(job.importStatus)">
                                {{ getSourceTypeDisplay(job.importStatus) }}
                                @if (isStrFileSource(job.importStatus) && getFilePathTooltip(job.importStatus)) {
                                  <i
                                    class="fa fa-file-text-o file-icon"
                                    [title]="getFilePathTooltip(job.importStatus)">
                                  </i>
                                }
                              </td>
                              <td>{{ formatUserName(job) }}</td>
                              <td>{{ formatDate(job.startDate) }}</td>
                              <td>
                                <span class="status-indicator"
                                  [ngClass]="getStatusClass(job.importStatus)"
                                  [class.clickable]="canDownloadFile(job)"
                                  (click)="canDownloadFile(job) ? downloadFile(job) : null"
                                  [title]="canDownloadFile(job) ? 'Click to download file' : (getStatusClass(job.importStatus) === 'status-partial' ? getErrorMessages(job.importStatus) : '')">
                                  <i class="status-icon"
                           [ngClass]="getStatusClass(job.importStatus) === 'status-success' ? 'fa fa-check-circle' : 
                                getStatusClass(job.importStatus) === 'status-partial' ? 'fa fa-exclamation-triangle' :
                                getStatusClass(job.importStatus) === 'status-error' ? 'fa fa-times-circle' : 'fa fa-question-circle'">
                                  </i>
                                  <i class="fa fa-download download-icon"
                                    [style.visibility]="canDownloadFile(job) ? 'visible' : 'hidden'"
                                    title="Download file">
                                  </i>
                                </span>
                              </td>
                            </tr>
                          }
                        </tbody>
                      </table>
                    }
                    @if (blastJobs().length === 0) {
                      <div class="no-data">
                        <p>{{ "BLAST_HISTORY.NO_DATA" | translate }}</p>
                      </div>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      }

      @if (isCollapsed()) {
        <div class="collapsed-content">
          <div class="collapsed-header"></div>
        </div>
      }
    </div>
  </div>
  <div class="col-md-1 p-0">
    <button
      class="collapse-button"
      (click)="toggleCollapse()"
      [title]="isCollapsed() ? 'Ouvrir' : 'Fermer'"
      >
      @if (!isCollapsed()) {
        <img src="assets/icon/double-arrow-left.svg" alt="" />
      }
      @if (isCollapsed()) {
        <img src="assets/icon/double-arrow-right.svg" alt="" />
      }
    </button>
  </div>
</div>